const SET_IS_MODAL_OPEN = (state, value) => { state.isModalOpen = value }
const SET_IS_IMGURL = (state, value) => { state.imgUrl = value }

export default {
  SET_IS_MODAL_OPEN,
  SET_IS_IMGURL
}
